export default __webpack_public_path__ + "static/Pagarme_Dashboard-bcbedadf8b242a64a46cb00cb9d1d778.png";